import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-dropdown',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.css',
})
export class DropdownComponent implements OnInit {
  @Input() label: string = '';
  @Input() dropdownId: string = 'dropdown';
  @Input() placeholder: string = 'placeholder';
  @Input() options: any = [];
  @Input() default: any = null;
  @Input() disabled: boolean = false;
  @Input() trackKey: string = '';
  @Input() displayKey: string = '';
  @Input() searchable: boolean = false;
  @Output() valueChange = new EventEmitter<any>();

  @ViewChild('dropdownMenu') dropdownMenuRef!: ElementRef;

  public selectedOption: any = '';
  public dropdownOpen: boolean = false;
  public groupdropdownOpen: boolean = false;

  searchTerm: string = '';
  searchResults: Array<any> = [];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private eRef: ElementRef,
  ) {}

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectOption(option: any, event: MouseEvent) {
    event.stopPropagation();
    this.dropdownOpen = false;
    if (this.selectedOption[this.displayKey] === option[this.displayKey])
      return;
    this.selectedOption = option;
    this.valueChange.emit(this.selectedOption);
  }

  ngOnInit() {
    if (this.default !== null) this.selectedOption = this.default;
    this.searchResults = [...this.options];
  }

  onSearchChange() {
    this.searchResults = [];
    this.searchResults = this.options.filter((option: any) =>
      option[this.trackKey]
        .toLowerCase()
        .includes(this.searchTerm.toLowerCase()),
    );
  }

  onEnterPress(): void {
    if (this.searchResults.length > 0) {
      const firstOption = this.options.find(
        (opt: any) =>
          opt[this.trackKey].toLowerCase() === this.searchTerm.toLowerCase(),
      );
      if (firstOption) this.selectOption(firstOption, new MouseEvent('click'));
    }
  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: EventTarget | null) {
    if (!this.eRef.nativeElement.contains(target)) {
      this.dropdownOpen = false;
    }
  }
}
